<!-- <template>
  <div>
    <mt-header title class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="container">
      <h3 class="dl_font1_color dl_margin1_top">
        {{ $t("重新设置支付密码") }}
      </h3>

      <mt-field label :placeholder="$t('验证码')" class="dl_margin4_top" v-model="code"></mt-field>
      <div class="dl_line"></div>
      <mt-field
        label
        :placeholder="$t('请设置六位密码')"
        class="dl_margin4_top"
        type="number"
        v-model.trim="password"
        :attr="{ maxlength: 6 }"
      ></mt-field>
      <div class="dl_line"></div>
      <mt-field
        label
        :placeholder="$t('请再次确认密码')"
        class="dl_margin4_top"
        type="number"
        v-model.trim="repassword"
        :attr="{ maxlength: 6 }"
      ></mt-field>
      <div class="dl_line"></div>
      <div style="padding: 5px">
        <Code @click.native="sendCode" ref="code"></Code>
      </div>
      <mt-button
        type="primary"
        class="dl_margin4_top"
        size="large"
        @click="doChange"
        >{{ $t("确认") }}</mt-button
      >
    </div>

    <VerifyPopup
      ref="refVerify"
      scene="credentials_update_pay_pwd"
      @onVerify="onSubmit"
    />
  </div>
</template> -->

<!-- <script>
import { validateEmpty } from "@/utils/validate";
import { Toast } from "mint-ui";
// import { httpSendMobileCode } from "@/api/login";
import { httpEditPayPassword } from "@/api/userCenter";
import VerifyPopup from "../../components/VerifyPopup";
// import Code from "@/components/Code";
export default {
  name: "ForgetPayPass",
  data() {
    return {
      mobile: this.$store.state.userInfo.mobile,
      password: "",
      repassword: "",
      code: "",
    };
  },
  methods: {
    goback: function () {
      // window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      this.$router.go(-1);
    },
    // sendCode: function () {
    //   const p = {
    //     username: this.mobile,
    //     scene: "password_reset",
    //   };
    //   httpSendMobileCode(p)
    //     .then((res) => {
    //       Toast(res.msg);
    //       this.$refs.code.run();
    //     })
    //     .catch(() => {});
    // },

    // 点击发送
    doChange: function () {
      if (validateEmpty(this.repassword) || validateEmpty(this.password)) {
        Toast(this.$t("empty"));
        return;
      } else if (this.password.length != 6) {
        Toast(this.$t("支付密码必须为六位"));
        return;
      }
      if (this.password != this.repassword) {
        Toast(this.$t("noequal"));
        return;
      }

      if (this.credentials) {
        this.onSubmit(this.credentials);
      } else {
        this.$refs.refVerify.show = true;
      }
    },
    onSubmit(credentials) {
      this.credentials = credentials;
      const payload = {
        pwd: this.password,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }

      // 修改密码接口
      httpEditPayPassword(payload)
        .then((res) => {
          Toast(res.msg);
          this.$router.push("/setUp");
          // this.$router.replace("/editPayPassword?`payload.credentials`");
        })
        .catch(() => {});
    },
  },
  activated: function () {
    // this.sendCode();
    this.password = "";
    this.repassword = "";
  },
  // components: { Toast, Code },
  components: { Toast, VerifyPopup },
};
</script> -->

<!-- <style scoped>
.container {
  padding: 10px;
}
.forget_pass {
  font-size: 14px;
  margin: 25px 0px;
}
a {
  color: #879baa;
}
.btn {
  color: #1e86db;
}
.mint-button--primary {
  background-color: #1e87d9;
}
/deep/.mint-field-core {
  -webkit-text-security: disc;
}
</style> -->
<template>
  <div id="rePayPassword">
    <mt-header fixed :title="$t('忘记支付密码')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div class="container">
      <div class="swiper">
        <p class="wx_fontSize3">
          {{ first ? $t("输入新密码") : $t("请再次输入") }}
        </p>
      </div>
      <div class="passContainer">
        <Password v-on:end="onEnd" ref="pass"></Password>
      </div>
    </div>
    <VerifyPopup
      ref="refVerify"
      scene="credentials_update_pay_pwd"
      @SwitchControll="clear"
      @onVerify="onSubmit"
    />
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import VerifyPopup from "@/components/VerifyPopup";
import Password from "@/components/Password";
import { httpEditPayPassword } from "@/api/userCenter";
export default {
  components: { Toast, Password, VerifyPopup },
  data() {
    return {
      first: true,
      firstValue: "",
    };
  },
  methods: {
    onEnd: function (val) {
      if (this.first) {
        this.first = false;
        this.firstValue = val;
        this.$refs.pass.reset();
        return;
      } else {
        if (this.firstValue != val) {
          Toast(this.$t("noequal"));
          this.first = true;
          this.firstValue = "";
          this.$refs.pass.reset();
          return;
        } else {
          this.pwd = val;
          if (this.credentials) {
            this.onSubmit(this.credentials);
          } else {
            this.$refs.refVerify.show = true;
          }
        }
      }
    },
    onSubmit(credentials) {
      this.credentials = credentials;
      const payload = {
        pwd: this.pwd,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }

      // 重置支付密码
      httpEditPayPassword(payload)
        .then((res) => {
          Toast(res.msg);

          this.$router.back();
        })
        .catch(() => {});
    },
    clear() {
      this.$refs.pass.reset();

      // this.first = true;
      // this.firstValue = "";
      // this.$nextTick(() => {
      //   this.first = true;
      //   this.firstValue = "";
      // });
      // this.$forceUpdate();
      // this.$set(this.first, "true");
      // this.$set(this.firstValue, "");
      this.first = true;
      // this.firstValue = "";
    },
  },
  activated() {
    this.first = true;
    this.firstValue = "";
    this.credentials = "";
  },

  watch: {},
};
</script>

<style scoped>
#rePayPassword {
  width: 100%;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  color: #4a4a4a;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.swiper p {
  margin: 5px;
}
/deep/.mint-header-title {
  overflow: inherit;
}
</style>
